import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ModalCore } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";
import { FormComissaoCorretora } from "./FormularioComissaoCorretora";
import { UseFeaturesFormulario } from "./hook/UseFeaturesFormulario";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";

interface IModalCommissionBroker {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalComissaoCorretora = ({
  openModal,
  setOpenModal,
}: IModalCommissionBroker) => {
  const { userPerfil } = useAuthContext();
  const { resetInputs } = useResetInputs();
  const { id } = useConfigPageContext();

  const { handleSubmit, loading: loadingSubmit } = UseFeaturesFormulario({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <>
      <ButtonCore
        disabled={
          userPerfil?.type_user === "USER" &&
          !userPerfil?.permissions.permissions.includes(
            valuesPermissions.COMMISSIONS_CORRETORA.CREATE.id
          )
        }
        startIcon={<AddIcon />}
        title="Criar Comissão"
        onClick={() => setOpenModal(true)}
      />

      <ModalCore
        loadingSubmit={loadingSubmit}
        open={openModal}
        setOpen={setOpenModal}
        sxStyle={{ width: "800px" }}
        title="Comissão da Corretora"
        subTitle="Esta é a grade de comissões que o escritório recebe."
        titleSubmit="Salvar e Fechar"
        onChange={() => handleSubmit(false)}
        onClickNotClose={!id ? () => handleSubmit(true) : undefined}
      >
        <FormComissaoCorretora />
      </ModalCore>
    </>
  );
};
